<template>
  <div style="height: 100%">
    <iframe :src="iurl" :name="iname" width="100%" frameborder="0" marginheight="0" marginwidth="0" style="height: 100%"></iframe>
  </div>
</template>
<script>
export default {
  name: "BasicIndex",
  data() {
    return {
      iurl: "",
      iname:"",
      iframeData: "",
      baseUrl: "",
      oecode:"",
      bcode:"",
    };
  },
  methods: {
    
    fatherFunction() {
      // console.log('父页面方法！');
      // this.iframeData
      var data = this.iframeData;
      // console.log(data.id)
      if (data.itemId) {
        this.$router.push({
          name: "jnquotedetail",
          params: { itemId: data.itemId }
        });
        var componentName = "jnquotedetail";
        this.openedTab = this.$store.state.openedTab;
        let tabNum = this.openedTab.indexOf(componentName);
        if (tabNum === -1) {
          this.$store.commit("addTab", componentName);
        } else {
          this.$store.commit("changeTab", componentName);
        }
      } else {
        if ("" == data.picEnquiry) {
          if (data.state == "2") {
            this.$router.push({ name: "mb", params: { id: data.id } });
            var componentName = "mb";
            this.openedTab = this.$store.state.openedTab;
            let tabNum = this.openedTab.indexOf(componentName);
            if (tabNum === -1) {
              this.$store.commit("addTab", componentName);
            } else {
              this.$store.commit("changeTab", componentName);
            }
          } else {
            console.log("data.id====" + data.id);
            this.$router.push({
              name: "createForm",
              params: {
                id: data.id,
                nbBxgsId: data.nbBxgsId,
                isnoBxgs: data.isnoBxgs
              }
            });
            var componentName = "createForm";
            this.openedTab = this.$store.state.openedTab;
            let tabNum = this.openedTab.indexOf(componentName);
            if (tabNum === -1) {
              this.$store.commit("addTab", componentName);
            } else {
              this.$store.commit("changeTab", componentName);
            }
          }
        } else {
          this.$router.push({
            name: "createPictureForm",
            params: { id: data.id }
          });
          var componentName = "createPictureForm";
          this.openedTab = this.$store.state.openedTab;
          let tabNum = this.openedTab.indexOf(componentName);
          if (tabNum === -1) {
            this.$store.commit("addTab", componentName);
          } else {
            this.$store.commit("changeTab", componentName);
          }
        }
      }


    },
    iFrameHeight() {  
      
      var ifm=document.getElementsByTagName('iframe');  
      
      for(let i=0;i<ifm.length;i++){
        // console.log(ifm)
        ifm[i].height = document.documentElement.clientHeight-39-91-20
      }
        
    }  ,
    openUrl(){
      console.group('openUrl');
      var url = document.location.toString();
      var arrUrl = url.split("//");

      var start = arrUrl[1].indexOf("/");
      var relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符

      if(relUrl.indexOf("?") != -1){
        relUrl = relUrl.split("?")[0];
      }
      // console.log(relUrl)
      var baseUrl = '';
      var vuetype = "?vue=1";
      var vuetype2 = "&vue=1";
      // var path = this.$router.currentRoute.fullPath;
      // var path = relUrl.replace("/v2-front/#","");
      const path = this.$route.path;
      console.log(`path: ${path}`);
      let id = this.$route.params.id;
      this.iname=path.replace('/','');
      const routeList = [
        ['/shop',process.env.NODE_ENV==='development'?'http://zhenpeifu.51qpb.com/wsaler/index.html':'http://zhenpeifu.qipeisq.com/wsaler/index.html'],
        ['/index','/uCenter/uc/?vue=1'],
        ['/quoteDetail',"/apsapi/quoteDetail/quoteDetailList?eFlag=cx" + vuetype2],/* 2 被选中 */
        ['/epcindexv2',"/epc/indexv2" + vuetype],/* 1 EPC查询 */
        ['/fullSale',"/apsapi/sale/queryOrderList?type=query" + vuetype2],/* 1 订单 */
        ['/sale',"/apsapi/sale/queryOrderList?type=query" + vuetype2],/* 1 订单 */
        ['/bxgsSale',"/purchase/queryOrderList?type=query" + vuetype2],/* 1 我的订单 */
        ['/OrderListseller',"/order/OrderList?userType=seller" + vuetype2],/* 2 售出订单 */
        ['/OrderList',"/order/OrderList" + vuetype+'&isInquiry=1'],/* 2 我的下单 */
        ['/queryEnquiryInfo',"/queryPrice/queryEnquiryInfo" + vuetype],/* 2 新建订单 */
        ['/cjqueryEnquiryInfo',"/queryPrice/queryEnquiryInfo" + vuetype],/* 1 创建订单 2 创建订单 */
        ['/cjOrderList',"/order/OrderList" + vuetype+'&isInquiry=1'],/* 2 订单列表 */
        ['/unsalableIndex', "/unsalable/index" + vuetype],/* 1 滞销外销 2 滞销单列表 */
        ['/exportBidding',"/export/exportBidding" + vuetype],/* 2 4s外销配件 */
        ['/unsalableInsert',"/unsalable/insert" + vuetype],/* 2 发布滞销单 */
        ['/unsalableBuyListFlag',"/unsalable/buyList?flag=mine" + vuetype2],/* 2 售出列表 */
        ['/unsalableBuyList',"/unsalable/buyList" + vuetype],/* 2 下单列表 */
        ['/fourSinsert',"/unsalable/insert" + vuetype],/* 1 滞销库存 2 发布滞销库存 */
        ['/fourSindexFlag',"/unsalable/index?flag=mine" + vuetype],/* 2 滞销库存列表 */
        ['/fourSbuyListFlag',"/unsalable/buyList?flag=mine" + vuetype2],/* 2 售出列表 */
        ['/fourSbuyList',"/unsalable/buyList" + vuetype],/* 2 下单列表 */
        ['/fourSexportBidding',"/export/exportBidding" + vuetype],/* 1 配件外销 2 外销列表 */
        ['/fourSaddBidding',"/export/addBidding" + vuetype],/* 2 发布外销包 */
        ['/maintainIndex',"/maintain/index" + vuetype],/* 1 保养 2 保养查询 */
        ['/jnmbPrice',`/jnmbPrice/createV2${vuetype}${this.$route.params.id?`&enquiryId=${this.$route.params.id}`:''}`],/* 1 秒报询价 2 秒报 */
        ['/jnxjPrice',"/Jninquiry/createForm"],/* 2 询价 */
        ['/queryenquiryinfolisteState',"/queryPrice/queryEnquiryInfoList?eState=100" + vuetype2],/* 2 暂存 */
        ['/doUserInfo',"/userCenter/doUserInfo" + vuetype],/* 1设置 2个人信息 */
        ['/mimaedit',"/userCenter/mimaedit" + vuetype],/* 2 修改密码 */
        ['/scopeedit',"/userCenter/scopeedit" + vuetype],/* 2 经营范围 */
        ['/queryuserdistrict',"/apsapi/Jnuserdistrict/queryuserdistrict" + vuetype],/* 2 报价区域 */
        // ["/Relation","/Cooperate/Relation" + vuetype],/* 2 合作关系 */
        ['/Relation','/cooperate/cooperate'],
        ["/chatlist","/chatlist/idxlist" + vuetype],/* 2 聊天记录 */
        ["/Feebalance","/Fee/balance" + vuetype],/* 2 查询充值 */
        ["/insreportsjd","/inscompany/insreportsjd" + vuetype],/* 1 报表统计 2 周期统计 */
        ["/insreport","/inscompany/insreport" + vuetype],/* 2 单日统计 */
        ["/insdirectsupplysjd","/supplystat/insdirectsupplysjd" + vuetype],/* 2 直供统计 */
        ["/inquiryList","/inscompany/inquiryList" + vuetype],/* 2 询价清单 */
        ["/EPCQueryList","/inscompany/EPCQueryList" + vuetype],/* 2 EPC查询清单 */
        ["/EPCQueryPartList","/inscompany/EPCQueryPartList" + vuetype],/* 2 EPC零件清单 */
        ["/cooperate","/cooperate/cooperate" + vuetype],/* 1 合作关系 2 配件商合作 */
        ['/damagecar',"/damagecar/cooperate" + vuetype],/* 2 竞拍商合作 */
        ['/mb',"/mb/detail?enquiryId=" + this.$route.params.id],
        ["/createPictureForm","/queryPrice/createPictureForm?enquiryId=" +this.$route.params.id +"&enquiryDTO.picEnquiry=1"],/* 这个可能后端没有*/
        ['/createForm',"/jninquiry/createForm?enquiryId=" + this.$route.params.id + "&nbBxgsId=" + this.$route.params.nbBxgsId + "&isnoBxgs=" + this.$route.params.isnoBxgs],
        ['/getInfoByOEcode',"/parts/getInfoByOEcode?OEcode="+this.OEcode+"&bcode="+this.bcode],/* nav OE码查询结果 */
        ['/report','/report/report'],
        ['/pjscheck','/pjscheck/notchecked'],
        ['/pjsupload','/pjsupload/index'],
        ['/yaInsreportsjd','/inscompany/yaInsreportsjd'],
        ['/insreportsjdDaily','/inscompany/insreportsjdDaily'],
        ['/shopmanager','/Jnmanager/index'],
        ['/queryEnquiryInfoListxlc','/queryPrice/queryEnquiryInfoListxlc?queryType=xlc'],
        ['/salvageCarList','/damagecar/index'],
        ['/salvageCarInsert','/damagecar/insert'],
        ['/successfulBidderList','/damagecar/index?is_select=1'],
        /* ['/jnquotedetail',"/apsapi/jnquote/jnquotedetail?enquiryInfoId=" + this.$route.params.itemId],
        ['/mb',"/mb/detail?enquiryId=" + id],
        ['/createPictureForm',"/queryPrice/createPictureForm?enquiryId=" + id + "&enquiryDTO.picEnquiry=1"], */
      ];
      const isExists = routeList.find(item=>item[0]===path);
      if(!isExists || !isExists.length) return;
      let iurl = isExists[1];
      if(isExists && Array.isArray(isExists)) {
        if(path==='/cjOrderList'){
          iurl+='&'+Object.entries(this.$route.query).map(i=>i.join('=')).join('&');
        }
        else if(path==='/queryPriceList'){
          iurl+='&'+Object.entries(this.$route.query).map(i=>i.join('=')).join('&');
        }
        this.iurl = iurl;
      }
      console.log(this.iurl);
      console.groupEnd();
    },
  },
   /*监听暂时去掉*/
  watch:{
    //方法2
    '$route' (to,from) {
      if(this.$route.name === this.$store.state.activeTab && to.path===from.path && to.fullPath!==from.fullPath){
        this.openUrl();
      }
      if(this.$route.path.indexOf('/shop')>=0){
        window.closeVueLoading();
      }
        /*console.log('watch')
        if(to.path =="/getInfoByOEcode" ) {   
          console.log('方法外显示')
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          this.iurl =
          baseUrl +
          "/parts/getInfoByOEcode?OEcode="+this.$route.query.OEcode+"&bcode="+this.$route.query.bcode; 
          console.log(this.iurl)
        }else if (to.path == "/index") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          this.iurl = baseUrl + "/uCenter/uc/?vue=1";
        } else if (to.path == "/queryPrice") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 报价
          this.iurl =
            baseUrl + "/apsapi/queryPrice/quotePriceList?eFlag=cx" + vuetype2;
        } else if (to.path == "/queryPriceList") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 报价列表
          this.iurl =
            baseUrl + "/apsapi/queryPrice/quotePriceList?eFlag=cx" + vuetype2;
        } else if (to.path == "/quoteDetail") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 被选中
          this.iurl =
            baseUrl + "/apsapi/quoteDetail/quoteDetailList?eFlag=cx" + vuetype2;
        } else if (to.path == "/epcindexv2") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 EPC查询
          this.iurl = baseUrl + "/epc/indexv2" + vuetype;
        } else if (to.path == "/sale") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 订单
          this.iurl = baseUrl + "/apsapi/sale/queryOrderList?type=query" + vuetype2;
        } else if (to.path == "/bxgsSale") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 我的订单
          this.iurl = baseUrl + "/purchase/queryOrderList?type=query" + vuetype2;
        } else if (to.path == "/OrderListseller") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 售出订单
          this.iurl = baseUrl + "/order/OrderList?userType=seller" + vuetype2;
        } else if (to.path == "/OrderList") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 我的下单
          this.iurl = baseUrl + "/order/OrderList" + vuetype;
        } else if (to.path == "/queryEnquiryInfo") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 新建订单
          this.iurl = baseUrl + "/queryPrice/queryEnquiryInfo" + vuetype;
        } else if (to.path == "/cjqueryEnquiryInfo") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 创建订单 2 创建订单
          this.iurl = baseUrl + "/queryPrice/queryEnquiryInfo" + vuetype;
        } else if (to.path == "/cjOrderList") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 2 订单列表
          this.iurl = baseUrl + "/order/OrderList" + vuetype;
        } else if (to.path == "/unsalableIndex") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 滞销外销 2 滞销单列表
          this.iurl = baseUrl + "/unsalable/index" + vuetype;
        } else if (to.path == "/exportBidding") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 4s外销配件
          this.iurl = baseUrl + "/export/exportBidding" + vuetype;
        } else if (to.path == "/unsalableInsert") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 发布滞销单
          this.iurl = baseUrl + "/unsalable/insert" + vuetype;
        } else if (to.path == "/unsalableBuyListFlag") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 售出列表
          this.iurl = baseUrl + "/unsalable/buyList?flag=mine" + vuetype2;
        } else if (to.path == "/unsalableBuyList") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 下单列表
          this.iurl = baseUrl + "/unsalable/buyList" + vuetype;
        } else if (to.path == "/fourSinsert") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 滞销库存 2 发布滞销库存
          this.iurl = baseUrl + "/unsalable/insert" + vuetype;
        } else if (to.path == "/fourSindexFlag") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 滞销库存列表
          this.iurl = baseUrl + "/unsalable/index?flag=mine" + vuetype;
        } else if (to.path == "/fourSbuyListFlag") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 售出列表
          this.iurl = baseUrl + "/unsalable/buyList?flag=mine" + vuetype2;
        } else if (to.path == "/fourSbuyList") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 下单列表
          this.iurl = baseUrl + "/unsalable/buyList" + vuetype;
        } else if (to.path == "/fourSexportBidding") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 配件外销 2 外销列表
          this.iurl = baseUrl + "/export/exportBidding" + vuetype;
        } else if (to.path == "/fourSaddBidding") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 2 发布外销包
          this.iurl = baseUrl + "/export/addBidding" + vuetype;
        } else if (to.path == "/maintainIndex") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 保养 2 保养查询
          this.iurl = baseUrl + "/maintain/index" + vuetype;
        } else if (to.path == "/jnmbPrice") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 秒报询价 2 秒报
          this.iurl = baseUrl + "/jnmbPrice/createV2" + vuetype;
        } else if (to.path == "/jnxjPrice") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 询价
          this.iurl = baseUrl + "/Jninquiry/createFormnew_20190924" + vuetype;
        } else if (to.path == "/queryenquiryinfolist") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 询价列表
          this.iurl =
            baseUrl + "/jnqueryprice/queryenquiryinfolist?eFlag=cx" + vuetype2;
        } else if (to.path == "/querypriceInfolist") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 列表
          this.iurl =
            baseUrl + "/queryprice/queryenquiryinfolist?eFlag=cx" + vuetype2;
        } else if (to.path == "/queryenquiryinfolisteState") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 暂存
          this.iurl =
            baseUrl + "/queryPrice/queryEnquiryInfoList?eState=100" + vuetype2;
        } else if (to.path == "/doUserInfo") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1设置 2个人信息
          this.iurl = baseUrl + "/userCenter/doUserInfo" + vuetype;
        } else if (to.path == "/mimaedit") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 修改密码
          this.iurl = baseUrl + "/userCenter/mimaedit" + vuetype;
        } else if (to.path == "/scopeedit") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 经营范围
          this.iurl = baseUrl + "/userCenter/scopeedit" + vuetype;
        } else if (to.path == "/queryuserdistrict") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 报价区域
          this.iurl =
            baseUrl + "/apsapi/Jnuserdistrict/queryuserdistrict" + vuetype;
        } else if (to.path == "/Relation") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 合作关系
          this.iurl = baseUrl + "/Cooperate/Relation" + vuetype;
        } else if (to.path == "/chatlist") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 聊天记录
          this.iurl = baseUrl + "/chatlist/idxlist" + vuetype;
        } else if (to.path == "/Feebalance") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //2 查询充值
          this.iurl = baseUrl + "/Fee/balance" + vuetype;
        } else if (to.path == "/insreportsjd") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          //1 报表统计 2 周期统计
          this.iurl = baseUrl + "/inscompany/insreportsjd" + vuetype;
        } else if (to.path == "/insreport") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 2 单日统计
          this.iurl = baseUrl + "/inscompany/insreport" + vuetype;
        } else if (to.path == "/insdirectsupplysjd") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 2 直供统计
          this.iurl = baseUrl + "/supplystat/insdirectsupplysjd" + vuetype;
        } else if (to.path == "/inquiryList") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 2 询价清单
          this.iurl = baseUrl + "/inscompany/inquiryList" + vuetype;
        } else if (to.path == "/EPCQueryList") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 2 EPC查询清单
          this.iurl = baseUrl + "/inscompany/EPCQueryList" + vuetype;
        } else if (to.path == "/EPCQueryPartList") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 2 EPC零件清单
          this.iurl = baseUrl + "/inscompany/EPCQueryPartList" + vuetype;
        } else if (to.path == "/cooperate") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 1 合作关系 2 配件商合作
          this.iurl = baseUrl + "/cooperate/cooperate" + vuetype;
        } else if (to.path == "/damagecar") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          // 2 竞拍商合作
          this.iurl = baseUrl + "/damagecar/cooperate" + vuetype;
        } else if (to.path == "/mb") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          this.iurl = baseUrl + "/mb/detail?enquiryId=" + this.$route.params.id;
        } else if (to.path == "/createPictureForm") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          this.iurl =
            baseUrl +
            "/queryPrice/createPictureForm?enquiryId=" +
            this.$route.params.id +
            "&enquiryDTO.picEnquiry=1";
        } else if (to.path == "/createForm") {
          let vuetype = "?vue=1";
          let vuetype2 = "&vue=1";
          let domain = document.domain;
          let baseUrl = "http://"+domain;
          this.iurl =
            baseUrl +
            "/jninquiry/createForm?enquiryId=" +
            this.$route.params.id +
            "&nbBxgsId=" +
            this.$route.params.nbBxgsId +
            "&isnoBxgs=" +
            this.$route.params.isnoBxgs;
        }else{
          this.openedTab = this.$store.state.openedTab;
          // tabNum 为当前点击的列表项在openedTab中的index，若不存在则为-1
          
          let tabNum = this.openedTab.indexOf(componentName);

          if (tabNum === -1) {
            // 该标签当前没有打开
            // 将componentName加入到已打开标签页state.openedTab数组中
            this.$store.commit("addTab", componentName);
          } else {
            // 该标签是已经打开过的，需要激活此标签页
            this.$store.commit("changeTab", componentName);
          }
          this.$router.push(componentName);

        }*/
        
    }   
  },
  created() {
    ['OEcode','bcode'].forEach(item=>{
      if(this.$route.query[item]) this[item] = this.$route.query[item]
    })
    console.log(this.$route.query)
    this.openUrl();
  },
  mounted() {
    var that = this;
    that.iFrameHeight();
    window.addEventListener("message", function(e) {
      // console.log(e.data.data);
      if (typeof e.data.data == "undefined") {
        return;
      }
      that.iframeData = e.data.data;
      console.log("监听页面点击跳转事件");
      
      // that.fatherFunction();

    }); //监听页面点击跳转事件
  },
};
</script>

<style scoped>
::v-deep .el-header {
  padding: 0 !important;
}
::v-deep .el-header,
::v-deep .el-footer {
  text-align: center;
}

</style>
